import { createTheme } from '@material-ui/core/styles';
import { esES } from '@material-ui/core/locale';

let themeSettings = {
  palette: {
    primary: {
      main: '#1a1a1a',
    },
    secondary: {
      main: '#8a8a8a',
    },
  }
};

const formatHex = (color, fallback) => {
  if (!color || color === 'null' || color === 'undefined') return fallback;
  const hex = color.toString().trim().replace(/^#+/, '');
  if (hex.length === 3) {
    const full = hex.split('').map(x => x + x).join('');
    return `#${full}`;
  }
  if (hex.length === 6 || hex.length === 8) {
    return `#${hex}`;
  }
  return fallback;
};

export const buildTheme = (color1 = null, color2 = null) => {
  themeSettings.palette.primary.main = formatHex(color1, '#1a1a1a');
  themeSettings.palette.secondary.main = formatHex(color2, '#8a8a8a');
  return createTheme(themeSettings, esES);
};

export const theme = createTheme(themeSettings, esES);
